import React from 'react';
import PropTypes from 'prop-types';

export const Icon = ({src}) => (
  <div className='hero-unit__icon-wrapper'>
    <img aria-hidden className='hero-unit__icon' role='presentation' src={src} />
  </div>
);

Icon.propTypes = {
  src: PropTypes.string
};
